module.exports = __webpack_public_path__ + "img/60f7669.jpg";